// extracted by mini-css-extract-plugin
module.exports = {"table":"roles-and-permissions_table__S2qXG","pageTitle":"roles-and-permissions_pageTitle__2xD76","textHeader":"roles-and-permissions_textHeader__2LKUo"};